// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ab2db206","239":"de3f2065","488":"51e26574","732":"70ff2c5c"}[chunkId] + ".chunk.js";
};